<h1 mat-dialog-title> Valida Postulación Nacimiento </h1> <br/>

<mat-dialog-content>
  
    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <p> Beneficiario </p>

            <mat-select *ngIf="data.carga" [(ngModel)]="data.beneficiario" [disabled]="data.deshabilitado" required>

                <mat-option *ngFor="let postulante of data.postulantes" value="{{postulante.id}}">

                    {{postulante.rut}} - {{postulante.dv}} {{postulante.nombres}} {{postulante.apellidoPaterno}}

                </mat-option>

            </mat-select>

            <input *ngIf="!data.carga" matInput [disabled]="true" [value]="data.beneficiario" />

        </mat-form-field>
    </p>
    <form #nacimientoForm=ngForm>
     <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Tipo Nacimiento </p>           
        </div>
        <div class="col-lg-5">
           
            <mat-select class="form-control" [(value)]="data.tipoNacimiento" name="tipoNacimiento" #tipoNacimiento="ngModel"
            (selectionChange)="inhabilitarPorTipo()"   [(ngModel)]="data.tipoNacimiento"  [disabled]="data.deshabilitado" required>
                 
                <mat-option value="0">
                    SELECCIONE....
                </mat-option>
                <mat-option *ngFor="let tipo of data.tipos"  [value]="tipo.id">
                    {{tipo.descripcion}}
                </mat-option>
            </mat-select>

        </div>

        <div class="col-lg-3"> </div>

    </div>
    <br />

    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Rut Hijo </label> </div>

        <div class="col-lg-5">

            <input id="rutHijo" name="rutHijo" #nombres="ngModel" [(ngModel)]="data.rutHijo"
                class="form-control"  required type="text"  [disabled]="data.deshabilitado" />

        </div>
        <div class="col-lg-3">   <div class="col-lg-3">
            <button class="btn btn-info" [disabled]="data.deshabilitado" (click)="buscarHijo(data.rutHijo)">
                Consultar
            </button>
        </div></div>
    </div>
    <br />
    
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> nombre Completo Hijo </label> </div>

        <div class="col-lg-5">

            <input id="nombreCompletoHijo" name="nombreCompletoHijo" #nombres="ngModel" [(ngModel)]="data.nombreCompletoHijo"
            class="form-control"  [disabled]="data.deshabilitado" required type="text" />


        </div>
        <div class="col-lg-3"> </div>
    </div>
    <br />
 
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Fecha Nacimiento </label> </div>

        <div class="col-lg-5">

            <input id="fechaNacimiento" name="fechaNacimiento" #nombres="ngModel" placeholder="Fecha Nacimiento" 
            class="form-control" type="date"  required [(ngModel)]="data.fechaNacimiento" [disabled]="data.deshabilitado" required />


        </div>
        <div class="col-lg-3"> </div>
    </div>
    <br />

    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Fecha Adopcion </label> </div>

        <div class="col-lg-5">

            <input id="fechaAdopcion" name="fechaAdopcion" #fechaAdopcion="ngModel" placeholder="Fecha fechaAdopcion"
            [disabled] = "data.fechaAdopcionDeshabilitado"  class="form-control" type="date"  [(ngModel)]="data.fechaAdopcion" [disabled]="data.deshabilitado" required />

        </div>
        <div class="col-lg-3"> </div>
    </div>
    <br />

    <p>
        <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPostulacion)">

        <i class = "fa fa-download"> </i> Descargar Archivos Ingresado </button>
    </p>
</form>
</mat-dialog-content> <br/>

<mat-dialog-actions>
    <div *ngIf="data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-warning" (click)="onEditarClick()">
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.mostrarAprobarButton" mat-button class="mat-raised-button btn-success" (click)="onAprobarClick()">
            <i class = "fa fa-check"> </i> Aprobar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class = "fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick(nacimientoForm)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>

    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>